import {
  PM_PUT_CONFERENCES_SUCCESS,
  PM_CHANGE_PASSCODE_SUCCESS,
  requestConferences,
} from "../../actions/passcodeManager";

import PasscodeHandler from "../../lib/PasscodeHandler";

const passcodeMiddleware = store => {
  const passcodeHandler = new PasscodeHandler(store);
  return next => async action => {
    let skipAction = false;
    if (action.type === PM_PUT_CONFERENCES_SUCCESS) {
      passcodeHandler.requestConferences(store.getState().passcodeManager.filter);
      skipAction = true;
    }
    if (action.type === PM_CHANGE_PASSCODE_SUCCESS) {
      store.dispatch(requestConferences(store.getState().passcodeManager.filter));
    }
    if (!skipAction) next(action);
  };
};

export default passcodeMiddleware;
